





































































































































































































































































































import { Component, Watch } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { SwIcon } from '@libs-uuif/shared/sw-icon';
import {  UserGroupExtension, CreateUser, CreateCustomer, AssignCustomers } from '@/shared/user-group';
import { SwModal, SwModalBody } from '@libs-uuif/shared/sw-modal';
import HelpContainerSlide from '@/core/msw-app-content/components/help-container-slide.vue';
import { State, Mutation } from 'vuex-class';
import { CoreStoreState, SetHelpContainerSlideVisiblePayload, SetHelpContentIdPayload, InfoState } from '@/core/core.store';
import { RootStoreState } from '@/store';
import { VuexMappedMutation } from '@libs-uuif/shared/common-types';
import  { MswApiService } from '@/shared/msw-api-service';
import { SwMessageContainer }  from '@libs-uuif/shared/message-service';
import { ApiError } from '@libs-uuif/shared/api-service';
import { confirmService, ConfirmOptions, ConfirmButton } from '@libs-uuif/shared/confirm-service';
import { helpContentData } from '@/shared/help-content-data/msw-help-data.ts';
import { SwScrollView } from '@libs-uuif/shared/sw-scroll-view';
import { UserGroupStoreState } from '@/modules/msw-products/components/msw-user-group/store';
import idb, { TENANTS_STORE_NAME } from '@/services/indexedDb.service';
import { CreateUserGroup } from '../../../../shared/user-group';
import { USERGROUP_STORE_NAME } from '../../../../services/indexedDb.service';
import MswAffiliationsTab from '@/modules/msw-products/components/msw-user-group/affiliations-tab.vue';
import * as decode from 'jwt-decode';
import localForageService from '../../../../services/localForageUpdate.service';
import { CreateElement, VNode } from 'vue';
import { currentUserKey } from '@/shared/msw-constants';
import { SwTabGroup, SwTabPage, TabProps } from '@sonicwall/unified-ui-framework/src/shared/sw-tab-layout';
import Userlist from '../../../msw-profile/components/userlist.vue';
import OrgUserList from '../../../msw-profile/components/orgUserList.vue';
import _ from 'lodash';
const cssPrefix = 'user-group-tab';

@Component({
  components: {
    AssignCustomers,
    CreateCustomer,
    CreateUser,
    UserGroupExtension,
    CreateUserGroup,
    HelpContainerSlide,
    SwIcon,
    SwModal,
    SwModalBody,
    SwMessageContainer,
    SwScrollView,
    SwTabGroup,
    SwTabPage,
    Userlist,
    OrgUserList,
    MswAffiliationsTab,
  },
})

export default class MswUserGroupsTab extends SwExtendedVue {
  cssPrefix = cssPrefix;

  selectedTabId: string = 'tab1';
  basicTabsProps: TabProps[] = [
    { tabId: 'tab1', label: this.$t('userGroups.userGroups')
      .toString(),
    },
  ];
  userGroupCount: number = 0;
  userGroupHelpFlag: boolean = true;
  userGroupCustomersTabHelpFlag: boolean = false;
  userGroupUsersTabHelpFlag: boolean = false;
  userGroupPermissionTabHelpFlag: boolean = false;
  userGroupCreateNewGroupHelpFlag:boolean = false;
  userGroupResponse: any = [];
  userGroupDetails: any = [];
  showExtension: boolean = false;
  selectedPartyGroupId: string = '';
  selectedExtensionTab : string = 'user-groups-users-tab';
  createUserModal: boolean = false;
  createCustomerModal: boolean = false;
  assignCustomerModal: boolean = false;
  usersListResponse: any = [];
  enbleUserInvite: boolean = false;
  customersListResponse: any = [];
  selectedUser: any = [];
  selectedCustomerResponse: any = [];
  addUsersId: string =  '';
  makeDefaultGroup: any = {
    GroupId: '',
    Mode: 'USER',
  };
  selectedCustomerResponseForUser: any = [];
  userGroupDataToBeDeleted: any = {
    bsendMail: false,
    userGroupList: [],
  };
  // newUserGroup: boolean = false;
  newGrpName: string = '';
  defaultCustomer: any = {};
  helplink:string = '';
  selectedCustomersForAssignCustomers: any = [];
  addedNewUserGroup: boolean = false;
  newUserGroupName: string = '';
  newUserGroupId: string = '';
  enableHelpContainer: boolean = true;
  options: ConfirmOptions;
  buttons: ConfirmButton[];
  userGroupResponseRaw : any = [];
  productGroupSelectedUser : any;
  callUpdatePermission : boolean = false;
  loadCustomerOnChange : string = '';
  scrollUserGroupToTop : boolean = false;
  showLoading : boolean = false;
  calUpdateUserCount : boolean = false;
  userGroupIdUpdate :string = '';
  updateCountFlag : boolean = false;
  showUserGroupList: boolean = false;
  width: any = '392px';
  inviteUserPopup: boolean = false;
  title: any = '';
  @Mutation
  readonly setHelpContainerSlideVisible: VuexMappedMutation<SetHelpContainerSlideVisiblePayload>;

  @State((state: RootStoreState) => state.CoreStoreModule.helpContainerSlideVisible)
  helpContainerSlideVisible: CoreStoreState['helpContainerSlideVisible'];

  @Mutation
  setHelpContentId: VuexMappedMutation<SetHelpContentIdPayload>;

  @State((state: RootStoreState) => state.MswUserGroupStoreModule.selectedUserGroup)
  selectedUserGroup: UserGroupStoreState['selectedUserGroup'];

  addUserGroup: boolean = false;
  @Watch('selectedUser')
  selectedUserChanged() {
    this.$store.commit('MswUserGroupStoreModule/mutate', { property: 'addUserFlag', with: this.selectedUser[0].isReadOnlyAccess !== 'YES' });
    // console.warn(this.selectedUser[0]);
  }
  beforeCreate() {
    this.$options.components!.CreateUserGroup = require('@/shared/user-group/component/create-user-group.vue').default;
    this.$options.components!.CreateUser = require('@/shared/user-group/component/create-user.vue').default;
    this.$options.components!.UserGroupExtension = require('@/shared/user-group/component/user-group-extension.vue').default;
    this.$options.components!.CreateCustomer = require('@/shared/user-group/component/create-customer.vue').default;
    this.$options.components!.AssignCustomers = require('@/shared/user-group/component/assign-customers.vue').default;
  }
  checkHelpFlag(flagName: string, extendUserGroup: boolean) {
    if (this.$store.getters.isLargeCustomer) {
      this.showExtension = extendUserGroup ? this.showExtension : false;
    } else {
      this.showExtension = extendUserGroup ? true : false;
    }
    // this.showExtension = extendUserGroup ? true : false;
    window.parent.postMessage({
      showHelp : this.showExtension,
    },                        '*');
    this.selectedExtensionTab = flagName;
    if (flagName === 'user-groups-help') {
      this.selectedExtensionTab = 'user-groups-users-tab';
    }
    switch (flagName) {
      case 'user-groups-help':
        this.initializeHelpFlag();
        this.userGroupHelpFlag = true;
        this.enableHelpContainer = true;
        break;
      case 'user-groups-customer-tab':
        this.initializeHelpFlag();
        this.userGroupCustomersTabHelpFlag = true;
        this.enableHelpContainer = false;
        break;
      case 'user-groups-users-tab':
        this.initializeHelpFlag();
        this.userGroupUsersTabHelpFlag = true;
        this.enableHelpContainer = false;
        break;
      case 'user-groups-permission-tab':
        this.initializeHelpFlag();
        this.userGroupPermissionTabHelpFlag = true;
        this.enableHelpContainer = false;
        break;
      case   'user-group-create-help':
        this.initializeHelpFlag();
        this.userGroupCreateNewGroupHelpFlag = true;
        this.enableHelpContainer = false;
      default:
        this.initializeHelpFlag();
        this.userGroupHelpFlag = true;
        this.enableHelpContainer = true;
        break;
    }
    helpContentData.forEach((node) => {
      if (node.helpId === flagName) {
        this.helplink = node.content;
      }
    });
    this.setHelpId(flagName);
  }

  initializeHelpFlag () {
    this.userGroupHelpFlag = false;
    this.userGroupCustomersTabHelpFlag = false;
    this.userGroupUsersTabHelpFlag = false;
    this.userGroupPermissionTabHelpFlag = false;
    this.userGroupCreateNewGroupHelpFlag = false;
  }

  created() {
    if (this.$store.getters.isLargeCustomer) {
      // this.showUserGroupList = true;
      this.loadCustomerForUserLargeCustomer();
    } else {
      this.loadCustomerForUser();
    }
    // this.setHelpContentId({ helpId: 'users-tab-user-groups' });
    this.setHelpId('users-tab-user-groups');
  }

  mounted() {
    // this.setHelpContentId({ helpId: 'users-tab-user-groups' });
    this.setHelpId('users-tab-user-groups');
    helpContentData.forEach((node) => {
      if (node.helpId === 'user-groups-help') {
        this.helplink = node.content;
      }
    });
    const currentUser: any = localStorage.getItem(currentUserKey);
    const token: any = decode(JSON.parse(currentUser)?.token || '');
    if (token.hasOwnProperty('orgbased') && token?.orgbased === 'YES') {
      this.basicTabsProps.push(
        {
          tabId: 'tab2',
          /* tslint:disable-next-line */
          label: (h: CreateElement): VNode => {
            return (
              <div style="display:flex;align-items:center;">
                <span style="margin-right:1rem;"> { this.$t('profile.affiliations') } </span>
                <div style="cursor:pointer;">
                  {/* tslint:disable-next-line */}
                  <SwIcon name="informational" props-size={15} v-tooltip={{ content: this.$t('affiliation.add.affliationTT'), compact: true, placement: 'bottom' }} ></SwIcon>
                </div>
              </div>
            ) as VNode;
          },
        },
      );
    }
    this.basicTabsProps.push(
      {
        tabId: 'tab3',
        label: this.$t('profile.users')
        .toString(),
      },
    );
  }
  setHelpId(value:string) {
    const temp:string[] = [];
    temp.push(value);
    this.setHelpContentId({ helpId:temp });
  }

  get isTriggerUserGroupApi() {
    return this.$store.getters['AccessManagementStoreModule/getTriggerUserGroupApi'];
  }

  onSelectTab(tabId: string) {
    const callApi = this.selectedTabId !== tabId;
    this.selectedTabId = tabId;
    window.parent.postMessage({ showHelp : false }, '*');
    if (this.selectedTabId === 'tab1') {
      this.showExtension = false;
      this.enableHelpContainer = true;
      helpContentData.forEach((node: any) => {
        if (node.helpId === 'user-groups-help') {
          this.helplink = node.content;
        }
      });
      if (this.isTriggerUserGroupApi) {
        if (this.$store.getters.isLargeCustomer) {
          this.loadCustomerForUserLargeCustomer();
        } else {
          this.loadCustomerForUser();
        }
      }
      if (callApi) {
        if (this.$store.getters.isLargeCustomer) {
          // this.showUserGroupList = true;
          this.loadCustomerForUserLargeCustomer();
        } else {
          this.loadCustomerForUser();
        }
      }
    }
    if (this.selectedTabId === 'tab2') {
      this.changeStyle('NO');
      this.$store.commit('AccessManagementStoreModule/setTriggerUserGroupApi', false);
    }

  }

  updateAvailableUserGroups(availableUG: any) {
    this.userGroupResponse = availableUG;
    this.userGroupCount = this.userGroupResponse?.length || 0;
  }

  loadUserGroups(forceFetch = false) {
    let userGrpResponseRecieved: any = [];
    this.$store.commit('startLoading');
    MswApiService.createCustomer.getUserGroup(forceFetch)
    .then((resp: any) => {
      this.userGroupResponse = [];
      userGrpResponseRecieved = resp || [];
      this.$store.commit('MswUserGroupStoreModule/setAffiliateGroups', resp?.affiliateGroups || []);
      // this.$store.commit('MswUserGroupStoreModule/mutate', { property: 'addUserFlag', with: resp.showAddProductGrplink === 'true' });
    })
    .then(() => {
      if (userGrpResponseRecieved.hasOwnProperty('userGroups')) {
        if (userGrpResponseRecieved.userGroups.length === 0) this.$store.commit('stopLoading');
        this.userGroupResponseRaw = userGrpResponseRecieved.userGroups;
        if (!this.$store.getters.isLargeCustomer) {
          this.showUserGroupList = false;
          userGrpResponseRecieved.userGroups.forEach((obj: any, index : any) => {
            if (index < 4 && !this.$store.getters.isLargeCustomer) {
              let permissionObj: any = {};
              this.$store.commit('startLoading');
              let tempObj: any = {};
              MswApiService.createCustomer.getUserGroupPermissions(obj.partyGroupId)
              .then((respPermission: any) => {
                permissionObj = respPermission.hasOwnProperty('content') ? respPermission.content.hasOwnProperty('PartyGroupPermissionSections') ?
                respPermission.content.PartyGroupPermissionSections : [] : [];
                tempObj = Object.assign(obj, {
                  permissionsForUserGroup: permissionObj,
                  usersForUserGroup: obj.hasOwnProperty('usersForUserGroup') ? obj.usersForUserGroup : [],
                });
                this.assignProductGroupsToUserGroup(obj, tempObj, true);
                if (this.userGroupResponse.length === userGrpResponseRecieved.userGroups.length) {
                  if (this.userGroupResponse.length > 3) {
                    if (this.addedNewUserGroup) {
                      const newUserGroup = this.userGroupResponse.filter((ele: any) => ele.partyGroupName === this.newUserGroupName);
                      const newUSerGroupId = this.userGroupResponse.findIndex((ele: any) => ele.partyGroupName === this.newUserGroupName);
                      if (newUserGroup.length > 0) {
                        this.userGroupResponse.splice(newUSerGroupId, 1);
                        this.userGroupResponse.unshift(newUserGroup[0]);
                      }
                    }
                  }
                }
                if (this.userGroupResponse.length === userGrpResponseRecieved.userGroups.length) {
                  this.showUserGroupList = true;
                  if (this.selectedUserGroup.length > 0 && this.selectedPartyGroupId) {
                    this.selectedExtensionTab = 'user-groups-customer-tab';
                    setTimeout(() => {
                      this.$store.dispatch('MswUserGroupStoreModule/userGroupSelected', [this.selectedPartyGroupId]);
                      this.checkHelpFlag('user-groups-users-tab', true);
                      this.groupExtension(this.selectedPartyGroupId, false, false);
                    },         500);
                    // this.showExtension = true;
                  }
                  this.selectedUser.length > 0 ? this.selectedGroup() : '';
                  this.$store.commit('stopLoading');
                }
              });
            } else {
              let tempObj: any = {};
              tempObj = Object.assign(obj, {
                usersForUserGroup: obj.hasOwnProperty('usersForUserGroup') ? obj.usersForUserGroup.map((users: any) => {
                  return users;
                }) : [],
                initialUsers: obj.hasOwnProperty('usersForUserGroup') ? obj.usersForUserGroup.map((users: any) => {
                  return users;
                }) : [],
              });
              // tempObj = Object.assign(obj);
              if (this.$store.getters.isLargeCustomer) {
                this.userGroupResponse.push(tempObj);
              } else {
                this.assignProductGroupsToUserGroup(obj, tempObj, false);
              }
              if (this.userGroupResponse.length === userGrpResponseRecieved.userGroups.length) {
                if (this.userGroupResponse.length > 3) {
                  if (this.addedNewUserGroup) {
                    const newUserGroup = this.userGroupResponse.filter((ele: any) => ele.partyGroupName === this.newUserGroupName);
                    const newUSerGroupId = this.userGroupResponse.findIndex((ele: any) => ele.partyGroupName === this.newUserGroupName);
                    if (newUserGroup.length > 0) {
                      this.userGroupResponse.splice(newUSerGroupId, 1);
                      this.userGroupResponse.unshift(newUserGroup[0]);
                    }
                  }
                }
              }
              if (this.userGroupResponse.length === userGrpResponseRecieved.userGroups.length) {
                this.showUserGroupList = true;
                if (this.selectedUserGroup.length > 0 && this.selectedPartyGroupId) {
                  setTimeout(() => {
                    this.$store.dispatch('MswUserGroupStoreModule/userGroupSelected', [this.selectedPartyGroupId]);
                    this.checkHelpFlag('user-groups-users-tab', true);
                    this.groupExtension(this.selectedPartyGroupId, false, false);
                  },         500);
                  // this.showExtension = true;
                }
                this.selectedUser.length > 0 ? this.selectedGroup() : '';
                this.$store.commit('stopLoading');
              }
            }
          });
        } else {
          this.$store.commit('stopLoading');
          this.userGroupResponse  = JSON.parse(JSON.stringify(userGrpResponseRecieved.userGroups));
        }
      } else {
        this.$store.commit('stopLoading');
      }
      this.userGroupCount = userGrpResponseRecieved.hasOwnProperty('userGroups') ? userGrpResponseRecieved.userGroups.length : 0;
      this.addUserGroup = userGrpResponseRecieved.showCreateUserGrplink === 'true';
    })
    .catch(() => {
      this.$store.commit('stopLoading');
    });
  }

  // tslint:disable-next-line:no-unused
  assignProductGroupsToUserGroup(obj : any, tempObj: any, pushIt : any, noPush = false) {
    // tslint:disable-next-line:no-unused
    const assignedProductGroups = obj.hasOwnProperty('associatedPGList') ? obj.associatedPGList : [];
    const assignedProductGroupss : any = [];
    const availableProductGroups : any = [];
    const key = (this.$store.getters.isLargeCustomer) ? 'MSSPID' : 'msspId';
    // const assignedNames = obj.hasOwnProperty('productGroupName') ? obj.productGroupName.split('^& ') : [];
    this.customersListResponse.map((ele : any) => {
      if (assignedProductGroups.find((item : any) => item.productGroupId.trim()  === ele.productGroupId.trim())) {
        if (!assignedProductGroupss.find((productGroup: any) => productGroup.productGroupId === ele.productGroupId)) {
          assignedProductGroupss.push({
            productGroupId : ele.productGroupId,
            productGroupName : ele.productGroupName,
            msspId: ele[key] || '',
            orgID: ele?.orgID || '',
          });
        }
      } else {
        if (!availableProductGroups.find((productGroup: any) => productGroup.productGroupId === ele.productGroupId)) {
          availableProductGroups.push({
            productGroupId : ele.productGroupId,
            productGroupName : ele.productGroupName,
            msspId: ele[key] || '',
            orgID: ele?.orgID || '',
          });
        }
      }
    });
    // placing default product group
    this.selectedCustomerResponse.map((ele : any) => {
      if (assignedProductGroups.find((item : any) => item.productGroupId.trim()  === ele.productGroupId.trim())) {
        if (!assignedProductGroupss.find((productGroup: any) => productGroup.productGroupId === ele.productGroupId)) {
          assignedProductGroupss.push({
            productGroupId : ele.productGroupId,
            productGroupName : ele.productGroupName,
            msspId: ele[key] || '',
            orgID: ele?.orgID || '',
          });
        }
      } else {
        if (!availableProductGroups.find((productGroup: any) => productGroup.productGroupId === ele.productGroupId)) {
          availableProductGroups.push({
            productGroupId : ele.productGroupId,
            productGroupName : ele.productGroupName,
            msspId: ele[key] || '',
            orgID: ele?.orgID || '',
          });
        }
      }
    });
    // tslint:disable-next-line:no-parameter-reassignment
    tempObj = Object.assign(tempObj, {
      assignedProductGroup: assignedProductGroupss,
      availableProductGroup: availableProductGroups,
    });
    if (!noPush) {
      if (pushIt) {
        this.userGroupResponse.unshift(tempObj);
      } else {
        this.userGroupResponse.push(tempObj);
      }
    }
    this.$store.commit('MswUserGroupStoreModule/setUserGroupResponseCopy', this.userGroupResponse || []);
    return tempObj;
  }

  async loadUsers(val? : any) {
    if (!this.$store.getters.isLargeCustomer || val) {
      this.$store.commit('startLoading');
    } else {
      this.showLoading = true;
    }
    MswApiService.createCustomer.listUsersForUserGroup(this.addUsersId)
    .then((resp: any) => {
      if (val) {
        this.usersListResponse = resp.hasOwnProperty('content') ? resp.content.hasOwnProperty('availbleUsers') ? resp.content.availbleUsers : [] : [];
        this.loadUserGroupTemp();
      } else {
        if (!this.$store.getters.isLargeCustomer) {
          this.$store.commit('stopLoading');
        }
        this.showLoading = false;
        this.usersListResponse = resp.hasOwnProperty('content') ? resp.content.hasOwnProperty('availbleUsers') ? resp.content.availbleUsers : [] : [];
      }
    });
  }

  changePermission(id: string, value: string, functionality: any, partyGroupPermissionSectionName: string) {
    this.$store.commit('startLoading');
    MswApiService.createCustomer.changePermssion(id, value, functionality.functionalityname)
    .then((rsp: any) => {
      this.$store.commit('stopLoading');
      if (rsp.operationStatus === 'NOK') {
        this.loadUserGroups();
        const message: InfoState = { infoType: 'high', infoMsg: rsp.msgDesc };
        this.$store.commit('displayMessage', message);
      } else {
        const message: InfoState = { infoType: 'success', infoMsg: rsp.msgDesc };
        this.$store.commit('displayMessage', message);
        this.userGroupResponse.map((ele: any, index: any) => {
          if (ele.partyGroupId === id) {
            this.userGroupResponse[index].permissionsForUserGroup.map((item: any, itemId: any) => {
              if (item.partyGroupPermissionSectionName === partyGroupPermissionSectionName) {
                item.partyGroupPermissionItems.map((list: any, listId: any) => {
                  if (list.functionalityname === functionality.functionalityname) {
                    list.permissionChoices.map((choices: any, chioiceId: any) => {
                      if (choices.permissionItemChoiceValue === value) {
                        // tslint:disable-next-line:max-line-length
                        this.userGroupResponse[index].permissionsForUserGroup[itemId].partyGroupPermissionItems[listId].permissionChoices[chioiceId].isSelected = 'TRUE';
                      } else {
                        // tslint:disable-next-line:max-line-length
                        this.userGroupResponse[index].permissionsForUserGroup[itemId].partyGroupPermissionItems[listId].permissionChoices[chioiceId].isSelected = 'FALSE';
                      }
                    });
                  }
                });
              }
            });
          }
        });
        // this.loadUserGroups();
      }
    });
  }

  loadCustomers() {
    this.customersListResponse = this.userGroupResponse.filter((item: any) => item.partyGroupId === this.addUsersId)[0].availableProductGroup;
    this.selectedCustomerResponse = this.userGroupResponse.filter((item: any) => item.partyGroupId === this.addUsersId)[0].assignedProductGroup;
  }

  listProductGroupForUserGroup(obj : any) {
    this.productGroupSelectedUser = obj;
    const selectedUserGroupIndex = this.userGroupResponse.findIndex((item: any) => item.partyGroupId === this.addUsersId);
    this.userGroupResponse[selectedUserGroupIndex].availableProductGroup = obj.availProductGroup;
    this.userGroupResponse[selectedUserGroupIndex].assignedProductGroup = obj.assigProductGroup;
  }

  groupExtension(partyGroupId: any, flag = false, open = false) {
    this.selectedPartyGroupId = partyGroupId;
    if (this.$store.getters.isLargeCustomer) {
      this.selectedGroup(open);
    } else {
      this.selectedGroup();
    }
    console.warn(flag);
    if (this.$store.getters.isLargeCustomer) {
      if (this.showExtension || open) {
        this.checkAndAddProductGroup();
      }
    } else {
      if (this.showExtension) {
        this.checkAndAddProductGroup();
      }
    }

  }

  selectedGroup(open = false) {
    this.addUsersId = this.userGroupResponse.filter((data:any) => (data.partyGroupId === this.selectedPartyGroupId))[0].partyGroupId || '';
    this.selectedUser =  this.userGroupResponse.filter((data:any) => (data.partyGroupId === this.selectedPartyGroupId));
    // debugger;
    const selectedUserObj = this.userGroupResponse.filter((data:any) => (data.partyGroupId === this.selectedPartyGroupId));
    if (!selectedUserObj[0].hasOwnProperty('loaded') && this.$store.getters.isLargeCustomer) {
      this.$store.commit('startLoading');
      this.loadUsersForUserGroupForLargeCustomer(selectedUserObj[0], open);
    } else if (this.$store.getters.isLargeCustomer) {
      this.showExtension = open ? true : this.showExtension;
      this.selectedUser = this.userGroupResponse.filter((data:any) => (data.partyGroupId === this.selectedPartyGroupId));
    } else {
      this.selectedUser = this.userGroupResponse.filter((data:any) => (data.partyGroupId === this.selectedPartyGroupId));
    }
  }
  loadUsersForUserGroupForLargeCustomer(selectedUserCopy : any, open = false) {
    Promise.all([
      MswApiService.createCustomer.getUserGroupPermissions(selectedUserCopy.partyGroupId),
      MswApiService.createCustomer.listUsersForUserGroup(selectedUserCopy.partyGroupId),
    ])
    .then((resp: any) => {
      this.loadPermissionAndUserList(resp, selectedUserCopy, open);
    });
  }
  loadPermissionAndUserList(resp : any, selectedUserCopy : any, open= false, dontSelect = false) {
    let tempObj : any = selectedUserCopy;
    let assignedUsers: any = [];
    let permissionObj: any = {};
    assignedUsers = resp[1]?.content?.assignedusers || [];
    assignedUsers &&
    assignedUsers.length > 0 &&
    assignedUsers.forEach((ele: any, index : any) => {
      const obj : any = {};
      obj['adminPartyId'] = ele.adminPartyId;
      obj['contactId'] = ele.contactId;
      obj['dtLastAccessDate'] = ele.dtLastAccessDate;
      obj['email'] = ele.emailAddress;
      obj['isReadOnlyAccess'] = ele.isReadOnlyAccess;
      obj['lastAccessDate'] = ele.lastAccessDate;
      obj['lastAccessTime'] = ele.lastAccessTime;
      obj['login'] = ele.logon;
      obj['name'] = ele.fullName;
      obj['partyGroupId'] = ele.partyGroupId;
      obj['partyId'] = ele.partyId;
      assignedUsers[index] = obj;
    });
    permissionObj = resp[0].hasOwnProperty('content') ? resp[0].content.hasOwnProperty('PartyGroupPermissionSections') ?
    resp[0].content.PartyGroupPermissionSections : [] : [];
    tempObj = Object.assign(tempObj, {
      usersForUserGroup: assignedUsers.length > 0 ? assignedUsers : [],
      permissionsForUserGroup: permissionObj,
      loaded : true,
    });
    MswApiService.createCustomer.getUserGroup()
        .then((resp: any) => {
          const localDataUGIndex = resp.userGroups.findIndex((ele: any) => ele.partyGroupId === selectedUserCopy.partyGroupId);
          resp.userGroups[localDataUGIndex] = tempObj;
          const changeUgInd = this.userGroupResponse.findIndex((ele: any) => ele.partyGroupId === selectedUserCopy.partyGroupId);
          if (changeUgInd > -1) {
            this.$set(this.userGroupResponse, changeUgInd, tempObj);
          }
          this.saveForageDataForUserGroup(resp, '');
          if (!dontSelect) {
            this.selectedUser = [tempObj];
          }
          if (open) {
            this.showExtension = open ? true : this.showExtension;
          }
          this.$store.commit('stopLoading');
        });
  }

  addNewCustomer(id: any) {
    this.loadCustomers();
    this.createUserModal = false;
    const customerSelected = this.selectedCustomerResponse.map((ele : any) => ele.productGroupName);
    this.$store.commit('MswUserGroupStoreModule/mutate', { property: 'initialSelectedList', with: customerSelected.sort() });
    this.createCustomerModal = true;
    this.assignCustomerModal = false;
    this.addUsersId = id;
    // this.newUserGroup = false;
  }

  addNewUser(id: any) {
    const createUserData = this.$refs.createUser as CreateUser;
    createUserData.inviteUser =  '';
    createUserData.inviteFirstNameUser = '';
    createUserData.inviteLastNameUser = '';
    this.createUserModal = true;
    this.createCustomerModal = false;
    this.assignCustomerModal = false;
    this.addUsersId = id;
    this.loadUsers();
    this.changeStyle('NO');
  }

  get createUserWidth() {
    return this.width;
  }

  get createUserTitle() {
    return this.title;
  }

  changeStyle(changeStyleVal: string) {
    if (changeStyleVal === 'YES') {
      this.width = '58rem';
      this.title = 'Invite User';
      this.inviteUserPopup = true;
    } else {
      this.width = '392px';
      this.title = '';
      this.inviteUserPopup = false;
      this.enbleUserInvite = !this.enbleUserInvite;
    }
  }

  addedUsers(data: any) {
    const selectedUserList: any = [];
    data.map((obj: any) => {
      if (obj.hasOwnProperty('invited')) {
        selectedUserList.push(obj);
      } else {
        selectedUserList.push(this.usersListResponse.filter((item: any) => item.emailAddress === obj));
      }
    });
    const usersTobeAdded: any = {
      bsendMail: null,
      contactLists: [],
    };
    // const usersToBeInvited: any = {
    //   contactTypeId: '10001',
    // };
    selectedUserList.map((obj: any) => {
      if (obj[0].hasOwnProperty('invited')) {
        // usersToBeInvited.partyGroupId = this.addUsersId;
        // usersToBeInvited.emailAddress = obj[0].emailAddress;
        // usersToBeInvited.firstName = obj[0].firstName;
        // usersToBeInvited.lastName = obj[0].lastName;
        // usersToBeInvited.contactTypeId = obj[0].contactTypeId;
      } else {
        usersTobeAdded.contactLists.push({
          partyGroupId: this.addUsersId,
          partyId: obj[0].partyId,
          action: 'add',
        });
      }
    });
    if (usersTobeAdded.contactLists.length > 0) {
      this.manageUserApi(usersTobeAdded);
    }
    // if (usersToBeInvited.hasOwnProperty('partyGroupId')) {
    //   this.inviteUsers(usersToBeInvited);
    // }
  }
  inviteUser(data: any) {
    const usersToBeInvited: any = {
      contactTypeId: '10001',
    };
    usersToBeInvited.partyGroupId = this.addUsersId;
    usersToBeInvited.emailAddress = data.emailAddress;
    usersToBeInvited.firstName = data.firstName;
    usersToBeInvited.lastName = data.lastName;
    usersToBeInvited.contactTypeId = data.contactTypeId;
    if (usersToBeInvited.hasOwnProperty('partyGroupId')) {
      const userGroup = this.userGroupResponse.filter((data:any) => (data.partyGroupId === this.addUsersId));
      if (userGroup.length > 0 && userGroup[0].isDefaultGroup.toLowerCase() === 'true' && data.contactTypeId === '10015' && !this.isorgBased) {
        // tslint:disable-next-line:max-line-length
        const message :InfoState = { infoMsg : 'You cannot add user of Reseller / Customer to the default user group since it would give admin access to all the tenants.' , infoType : 'failed' };
        this.$store.commit('enqueueMessage', message);
        return;
      }
      const email = JSON.parse(localStorage.getItem(currentUserKey) as any).email;
      // tslint:disable-next-line:max-line-length
      if (email && email.split('@')[1] !== data.emailAddress.split('@')[1] && data.contactTypeId === '10001' && userGroup.length > 0 && userGroup[0].isDefaultGroup.toLowerCase() === 'true') {
        this.buttons = [
          { key: 'cancel', name: 'Cancel', isDefault: true },
          { key: 'yes', name: 'Yes' },
        ];
        this.options = {
          status: 'high',
          title: 'Confirmation',
          // tslint:disable-next-line:no-unused
          message : (h: CreateElement): VNode => {
            return h('div', {
              // tslint:disable-next-line:max-line-length
              domProps: { innerHTML: 'Adding a user to default user group would give admin access to all the tenants. Are you sure you want to add to default user group ?' },
            });
          },
          buttons: this.buttons,
        };
        confirmService.confirm(this.options)
        .then((key) => {
          if (key === 'yes') {
            this.inviteUsers(usersToBeInvited, false);
          }
        });
      } else {
        this.inviteUsers(usersToBeInvited, false);
      }
    }
  }
  manageUserApi(data: any) {
    this.$store.commit('startLoading');
    MswApiService.createCustomer.manageUsers(data)
    .then((resp: any) =>  {
      this.$store.commit('stopLoading');
      // this.selectedUser[0].usersForUserGroup.splice(0, this.selectedUser[0].usersForUserGroup.length); // ??
      if (resp.operationStatus === 'NOK') {
        const message: InfoState = { infoType: 'high', infoMsg: resp.msgDesc };
        this.$store.commit('displayMessage', message);
      } else {
        if (this.$store.getters.isLargeCustomer) {
          this.callUpdatePermission = false;
          // idb.refreshStore(USERGROUP_STORE_NAME)
          //   .then(() => {
          //     // have to make change here.
          //     this.loadUserGroupTemp();
          //   });
          this.$store.commit('startLoading');
          MswApiService.createCustomer.getUserGroup()
            // tslint:disable-next-line:no-unused
            .then((resp: any) => {
              let response = resp;
              const changedResponse = localForageService.addUserToUserGroup(response, data, this.usersListResponse, this.userGroupResponse);
              this.userGroupResponse = changedResponse.userGroupResponseOut;
              response = changedResponse.respOut;
              this.selectedUser[0].usersForUserGroup = this.userGroupResponse[changedResponse.index].usersForUserGroup;
              this.$set(this.userGroupResponse , changedResponse.index, this.userGroupResponse[changedResponse.index]);
              this.saveForageDataForUserGroup(response, '');
              this.callUpdatePermission = true;
              this.$store.commit('stopLoading');
            });
        } else {
          this.loadUserGroupTemp();
        }
        const message: InfoState = { infoType: 'success', infoMsg: resp.msgDesc };
        this.$store.commit('displayMessage', message);
      }
    });
  }
  loadUserGroupTemp() {
    this.callUpdatePermission = false;
    this.$store.commit('startLoading');
    MswApiService.createCustomer.getUserGroup(true)
    .then((resp: any) => {
      this.$store.commit('stopLoading');
      for (let i = 0; i < resp.userGroups.length; i += 1) {
        if (resp.userGroups[i].partyGroupId === this.selectedUser[0].partyGroupId) {
          const listIndex = this.userGroupResponse.findIndex((ele : any) => ele.partyGroupId === resp.userGroups[i].partyGroupId);
          this.userGroupResponse[listIndex].usersForUserGroup = resp.userGroups[i].usersForUserGroup;
          this.$set(this.userGroupResponse , listIndex, this.userGroupResponse[listIndex]);
          const newListIndex = this.userGroupResponseRaw.findIndex((ele : any) => ele.partyGroupId === resp.userGroups[i].partyGroupId);
          this.userGroupResponseRaw[newListIndex].usersForUserGroup = resp.userGroups[i].usersForUserGroup;
          this.selectedUser[0].usersForUserGroup = resp.userGroups[i].usersForUserGroup;
          // this.newUserGroupResponse[i].usersForUserGroup = resp.userGroups[i].usersForUserGroup;
          this.callUpdatePermission = true;
          break;
        }
      }
    });
  }

  inviteUsers(data: any, booleanValue? :any) {
    this.$store.commit('startLoading');
    MswApiService.createCustomer.addUsers(data, booleanValue)
    .then((resp: any) =>  {
      if (resp.msgCode === 'MSWAPP:ADDUSERWARNING') {
        this.$store.commit('stopLoading');
        this.confirmAdd(data, resp.msgDesc);
      } else if (resp.operationStatus === 'NOK') {
        this.$store.commit('stopLoading');
        if (resp.msgCode === 'MSWAPP:ADDUSERFAILURE') {
          this.modalClose();
        }
        const message: InfoState = { infoType: 'failed', infoMsg: resp.msgDesc };
        console.warn(message);
        this.$store.commit('enqueueMessage', message);
      } else {
        if (this.$store.getters.isLargeCustomer) {
          this.updateCountFlag = false;
          MswApiService.createCustomer.getUserGroup()
          .then((res: any) => {
            const changedUserGroupIndex = res.userGroups.findIndex((ele : any) => ele.partyGroupId === data.partyGroupId);
            if (res.userGroups[changedUserGroupIndex].hasOwnProperty('usersForUserGroup')) {
              res.userGroups[changedUserGroupIndex].usersForUserGroup.push(resp.addedUserDetail);
            } else {
              let tempObj: any = res.userGroups[changedUserGroupIndex];
              tempObj = Object.assign(tempObj, {
                usersForUserGroup: [resp.addedUserDetail],
                initialUsers: [resp.addedUserDetail],
              });
              res.userGroups.splice(changedUserGroupIndex, 1, tempObj);
            }
            const ugIndex = this.userGroupResponse.findIndex((ele : any) => ele.partyGroupId === data.partyGroupId);
            this.userGroupResponse[ugIndex] = res.userGroups[changedUserGroupIndex];
            this.$set(this.userGroupResponse , ugIndex , this.userGroupResponse[ugIndex]);
            this.saveForageDataForUserGroup(res, res.userGroups[changedUserGroupIndex].partyGroupId);
            this.updateCountFlag = true;
          });
          this.$store.commit('stopLoading');
          this.modalClose();
          const message: InfoState = { infoType: 'success', infoMsg: resp.msgDesc };
          this.$store.commit('displayMessage', message);
        } else {
          this.modalClose();
          this.$store.commit('startLoading');
          this.loadUsers(true);
          // this.loadUserGroups();
          const message: InfoState = { infoType: 'success', infoMsg: resp.msgDesc };
          this.$store.commit('displayMessage', message);
        }
      }
    });
  }

  get isorgBased() {
    let orgbased: boolean = false;
    const currentUser: any = localStorage.getItem(currentUserKey);
    const token: any = decode(JSON.parse(currentUser)?.token || '');
    if (token.hasOwnProperty('orgbased') && token?.orgbased === 'NO') {
      orgbased = false;
    } else {
      orgbased = true;
    }
    return orgbased;
  }
  confirmAdd(data : any, resp : any) {
    this.buttons = [
      { key: 'cancel', name: 'Cancel', isDefault: true },
      { key: 'yes', name: 'Yes' },
    ];
    this.options = {
      status: 'high',
      title: 'Confirmation',
      message: resp,
      buttons: this.buttons,
    };
    confirmService.confirm(this.options)
    .then((key) => {
      if (key === 'yes') {
        this.$store.commit('startLoading');
        MswApiService.createCustomer.addUsers(data, true)
    .then((resp: any) =>  {
      this.$store.commit('stopLoading');
      if (resp.msgCode === 'MSWAPP:ADDUSERWARNING') {
        this.confirmAdd(data, resp.msgDesc);
      } if (resp.operationStatus === 'NOK') {
        const message: InfoState = { infoType: 'high', infoMsg: resp.msgDesc };
        this.$store.commit('displayMessage', message);
      } else {
        this.modalClose();
        this.$store.commit('startLoading');
        this.loadUsers(true);
        this.loadUserGroups();
        // this.loadUserGroups();
        const message: InfoState = { infoType: 'success', infoMsg: resp.msgDesc };
        this.$store.commit('displayMessage', message);
      }
    });
      } else {
      }
    });
  }

  modalClose() {
    this.createUserModal = false;
    this.createCustomerModal = false;
    this.assignCustomerModal = false;
  }

  updateUserGroup(data : any) {
    this.callUpdatePermission = false;
    if (this.$store.getters.isLargeCustomer) {
      Promise.all([
        this.$store.dispatch('DashBoardStoreModule/populateCustomerWidgets', false),
        MswApiService.createCustomer.getUserGroup(false),
      ])
      .then((resp: any) => {
        data.partyProductGroupList.forEach((ele : any) => {
          const pgIndex = resp[0].prodGroupLicenseStatus.findIndex((item : any) => item.productGroupId === ele.productGroupId);
          const ugIndex = resp[1].userGroups.findIndex((item : any) => item.partyGroupId === ele.partyGroupId);
          const pgIndex1 = this.selectedCustomerResponseForUser.findIndex((item : any) => item.productGroupId === ele.productGroupId);
          const pgIndex2 = this.customersListResponse.findIndex((item : any) => item.productGroupId === ele.productGroupId);
          const ugIndex1 = this.userGroupResponseRaw.findIndex((item : any) => item.partyGroupId === ele.partyGroupId);
          const ugIndex2 = this.userGroupResponse.findIndex((item : any) => item.partyGroupId === ele.partyGroupId);
          // console.warn(`${pgIndex} -- ${ugIndex} -- ${pgIndex1} -- ${pgIndex2} -- ${ugIndex1} -- ${ugIndex2}`);
          if (pgIndex > -1 && ugIndex > -1) {
            // Adding usergroup to product group
            // tslint:disable-next-line:max-line-length
            const assignedNames = resp[0].prodGroupLicenseStatus[pgIndex].hasOwnProperty('partyGroupName') ? resp[0].prodGroupLicenseStatus[pgIndex].partyGroupName.trim().length > 0 ? resp[0].prodGroupLicenseStatus[pgIndex].partyGroupName.split(', ') : [] : [];
            if (assignedNames.findIndex((obj : any) => obj.trim() === resp[1].userGroups[ugIndex].partyGroupName.trim()) === -1) {
              if (assignedNames.length > 0) {
                // tslint:disable-next-line:max-line-length
                resp[0].prodGroupLicenseStatus[pgIndex].partyGroupName = `${resp[0].prodGroupLicenseStatus[pgIndex].partyGroupName}, ${resp[1].userGroups[ugIndex].partyGroupName}`;
              } else {
                resp[0].prodGroupLicenseStatus[pgIndex].partyGroupName = resp[1].userGroups[ugIndex].partyGroupName;
              }
              this.selectedCustomerResponseForUser[pgIndex1].partyGroupName = resp[0].prodGroupLicenseStatus[pgIndex].partyGroupName;
              if (pgIndex2 === -1) {
                if (this.defaultCustomer.productGroupId === resp[0].prodGroupLicenseStatus[pgIndex].productGroupId) {
                  this.defaultCustomer.partyGroupName = resp[0].prodGroupLicenseStatus[pgIndex].partyGroupName;
                }
                const i = this.selectedCustomerResponse.findIndex((ele : any) => ele.productGroupId === resp[0].prodGroupLicenseStatus[pgIndex].productGroupId);
                if (i > -1) {
                  this.selectedCustomerResponse[i].partyGroupName = resp[0].prodGroupLicenseStatus[pgIndex].partyGroupName;
                  this.$set(this.selectedCustomerResponse, i, this.selectedCustomerResponse[i]);
                }
              } else {
                this.$set(this.customersListResponse, pgIndex2, this.customersListResponse[pgIndex2]);
                this.customersListResponse[pgIndex2].partyGroupName = resp[0].prodGroupLicenseStatus[pgIndex].partyGroupName;
              }
              // console.warn(this.customersListResponse[pgIndex2]);
            }
            // Adding product group to user group
            // tslint:disable-next-line:max-line-length
            const productAssignedNames = resp[1].userGroups[ugIndex].hasOwnProperty('productGroupName') ? resp[1].userGroups[ugIndex].productGroupName.trim().length > 0 ? resp[1].userGroups[ugIndex].productGroupName.split('^& ') : [] : [];
            if (productAssignedNames.findIndex((obj : any) => obj.trim() === resp[0].prodGroupLicenseStatus[pgIndex].productGroupName.trim()) === -1) {
              if (productAssignedNames.length > 0) {
                // tslint:disable-next-line:max-line-length
                resp[1].userGroups[ugIndex].productGroupName = `${resp[1].userGroups[ugIndex].productGroupName}^& ${resp[0].prodGroupLicenseStatus[pgIndex].productGroupName}`;
              } else {
                resp[1].userGroups[ugIndex].productGroupName = resp[0].prodGroupLicenseStatus[pgIndex].productGroupName;
              }
              // console.warn(resp[1].userGroups[ugIndex]);
              this.userGroupResponseRaw[ugIndex1].productGroupName = resp[1].userGroups[ugIndex].productGroupName;
              this.userGroupResponse[ugIndex2].productGroupName = resp[1].userGroups[ugIndex].productGroupName;
              // console.warn(this.userGroupResponseRaw[ugIndex1]);
              // console.warn(this.userGroupResponse[ugIndex2]);
            }
          }
          this.$set(this.selectedCustomerResponseForUser, pgIndex1, this.selectedCustomerResponseForUser[pgIndex1]);
          this.$set(this.userGroupResponseRaw, ugIndex1, this.userGroupResponseRaw[ugIndex1]);
          this.$set(this.userGroupResponse, ugIndex2, this.userGroupResponse[ugIndex2]);
          // tslint:disable-next-line:max-line-length
          this.$set(this.userGroupResponse, ugIndex2 , this.assignProductGroupsToUserGroup(this.userGroupResponse[ugIndex2], this.userGroupResponse[ugIndex2], false, true));
          this.groupExtension(this.selectedPartyGroupId);
          this.callUpdatePermission = true;
        });
        this.saveForageDataForUserGroup(resp[1], '');
        this.saveForageData(resp[0], '');
      });
    } else {
      this.loadUserGroups();
      this.modalClose();
    }
  }
  addedCustomers(data: any) {
    this.loadCustomerOnChange = '';
    this.$store.commit('startLoading');
    const dataToBeManaged:any = {
      partyProductGroupList: [],
      bsendMail: false,
    };
    const updatedUserGroup:any = [];
    data.map((ele: any) => {
      dataToBeManaged.partyProductGroupList.push({
        productGroupId: ele.productGroupId,
        partyGroupId: this.addUsersId,
      });
      updatedUserGroup.push({
        MSSPId: ele.msspId,
        productGroupId: ele.productGroupId,
        productGroupName: ele.productGroupName,
      });
    });
    MswApiService.createCustomer.postManageUserProductGroup(dataToBeManaged)
    .then((resp: any) => {
      this.$store.commit('stopLoading');
      if (resp.operationStatus === 'NOK') {
        const message: InfoState = { infoType: 'high', infoMsg: resp.msgDesc };
        this.$store.commit('displayMessage', message);
        this.$store.commit('stopLoading');
      } else {
        if (this.$store.getters.isLargeCustomer) {
          this.callUpdatePermission = false;
          Promise.all([
            this.$store.dispatch('DashBoardStoreModule/populateCustomerWidgets', false),
            MswApiService.createCustomer.getUserGroup(false),
          ])
        .then((resp: any) => {
          const changedUserGroupId = resp[1].userGroups.findIndex((ele : any) => ele.partyGroupId === dataToBeManaged.partyProductGroupList[0].partyGroupId);
          const localChangedUG = this.userGroupResponse.findIndex((ele : any) => ele.partyGroupId === dataToBeManaged.partyProductGroupList[0].partyGroupId);
          this.selectedCustomerResponse.forEach((ele : any) => {
            const ind = dataToBeManaged.partyProductGroupList.findIndex((i : any) => i.productGroupId === ele.productGroupId);
            if (ind === -1) {
              const localPgIndex = this.customersListResponse.findIndex((i : any) => i.productGroupId === ele.productGroupId);
              // product group removed
              const pgIndex = resp[0].prodGroupLicenseStatus.findIndex((element : any) => element.productGroupId === ele.productGroupId);
              if (resp[0].prodGroupLicenseStatus[pgIndex].partyGroupName.indexOf(`, ${resp[1].userGroups[changedUserGroupId].partyGroupName}`) > -1) {
                // tslint:disable-next-line:max-line-length
                resp[0].prodGroupLicenseStatus[pgIndex].partyGroupName = resp[0].prodGroupLicenseStatus[pgIndex].partyGroupName.replace(`, ${resp[1].userGroups[changedUserGroupId].partyGroupName}`, '');
              } else if (resp[0].prodGroupLicenseStatus[pgIndex].partyGroupName.indexOf(`${resp[1].userGroups[changedUserGroupId].partyGroupName}`) > -1) {
                // tslint:disable-next-line:max-line-length
                resp[0].prodGroupLicenseStatus[pgIndex].partyGroupName = resp[0].prodGroupLicenseStatus[pgIndex].partyGroupName.replace(`${resp[1].userGroups[changedUserGroupId].partyGroupName}`, '');
              }
              if (localPgIndex !== -1) {
                this.customersListResponse[localPgIndex].partyGroupName = resp[0].prodGroupLicenseStatus[pgIndex].partyGroupName;
              } else {
                if (this.defaultCustomer.productGroupId === ele.productGroupId) {
                  this.defaultCustomer.partyGroupName = resp[0].prodGroupLicenseStatus[pgIndex].partyGroupName;
                }
                const i = this.selectedCustomerResponse.findIndex((ele : any) => ele.productGroupId === ele.productGroupId);
                if (i > -1) {
                  this.selectedCustomerResponse[i].partyGroupName = resp[0].prodGroupLicenseStatus[pgIndex].partyGroupName;
                }
              }
              // default pg needs to be taken care heree
            }
          });
          let productGroupNameStr = '';
          dataToBeManaged.partyProductGroupList.forEach((ele : any, index : any) => {
            const findIndexInRespPG = resp[0].prodGroupLicenseStatus.findIndex((element : any) => element.productGroupId === ele.productGroupId);
            const selectedIndex = this.selectedCustomerResponse.findIndex((i : any) => i.productGroupId === ele.productGroupId);
            if (selectedIndex === -1) {
              // product group Added
              resp[0].prodGroupLicenseStatus[findIndexInRespPG].partyGroupName += `, ${resp[1].userGroups[changedUserGroupId].partyGroupName}`;
              const localPgIndex = this.customersListResponse.findIndex((i : any) => i.productGroupId === ele.productGroupId);
              if (localPgIndex !== -1) {
                this.customersListResponse[localPgIndex].partyGroupName = resp[0].prodGroupLicenseStatus[findIndexInRespPG].partyGroupName;
              } else {
                if (this.defaultCustomer.productGroupId === ele.productGroupId) {
                  this.defaultCustomer.partyGroupName = resp[0].prodGroupLicenseStatus[findIndexInRespPG].partyGroupName;
                }
                const i = this.selectedCustomerResponse.findIndex((ele : any) => ele.productGroupId === ele.productGroupId);
                if (i > -1) {
                  this.selectedCustomerResponse[i].partyGroupName = resp[0].prodGroupLicenseStatus[findIndexInRespPG].partyGroupName;
                }
              }
            }
            if (index === dataToBeManaged.partyProductGroupList.length - 1) {
              productGroupNameStr += ` ${resp[0].prodGroupLicenseStatus[findIndexInRespPG].productGroupName}`;
            } else {
              productGroupNameStr += ` ${resp[0].prodGroupLicenseStatus[findIndexInRespPG].productGroupName}^&`;
            }
          });
          resp[1].userGroups[changedUserGroupId].productGroupName = productGroupNameStr;
          this.userGroupResponse[localChangedUG].productGroupName = productGroupNameStr;
          this.userGroupResponse[localChangedUG].associatedPGList = updatedUserGroup;
          resp[1].userGroups[changedUserGroupId].associatedPGList = updatedUserGroup;
          // this.customersListResponse[customerListIndex].productGroupName = productGroupNameStr;
          this.saveForageData(resp[0], '');
          // tslint:disable-next-line:max-line-length
          this.userGroupResponse[localChangedUG] = this.assignProductGroupsToUserGroup(this.userGroupResponse[localChangedUG], this.userGroupResponse[localChangedUG], false, true);
          this.selectedUser[0].assignedProductGroup = this.userGroupResponse[localChangedUG].assignedProductGroup;
          this.selectedUser[0].availableProductGroup = this.userGroupResponse[localChangedUG].availableProductGroup;
          resp[1].userGroups[changedUserGroupId].assignedProductGroup = this.selectedUser[0].assignedProductGroup;
          resp[1].userGroups[changedUserGroupId].availableProductGroup = this.selectedUser[0].availableProductGroup;
          this.saveForageDataForUserGroup(resp[1], '');
          if (!this.selectedUser[0].hasOwnProperty('usersForUserGroup')) {
            this.selectedUser[0]['usersForUserGroup'] = [];
          }
          this.$set(this.selectedUser, 0 , this.selectedUser[0]);
          this.callUpdatePermission = true;
        });
        } else {
          this.loadCustomerOnChange = this.selectedUser[0].partyGroupId;
        }
        const message: InfoState = { infoType: 'success', infoMsg: resp.msgDesc };
        this.$store.commit('displayMessage', message);
      }
    })
    .then(() => {
      // this.userGroupResponse = [];
    })
    .then(() => {
      // this.loadUserGroupTemp();
    })
    .catch((error: ApiError) => {
      this.$store.commit('stopLoading');
      this.loadUserGroups();
      const message: InfoState = { infoType: 'high', infoMsg: error.message || 'Unknown Error' };
      this.$store.commit('displayMessage', message);
    });
  }

  addNewUserGroup(newUserGroupname: string, flag: boolean, index: any) {
    // this.newUserGroup = true;
    this.newGrpName = newUserGroupname;
    this.scrollUserGroupToTop = false;
    // this.loadCustomerForUser();
    if (flag) {
      // if (this.newUserGroup) {
      //   this.createUserModal = false;
      //   this.createCustomerModal = true;
      //   this.assignCustomerModal = false;
      //   // this.customersListResponse = this.userGroupResponse.filter((item: any) => item.partyGroupId === this.addUsersId)[0].availableProductGroup;
      // }
      // this.userGroupResponse.push({ name: newUserGroup });
      this.$store.commit('startLoading');
      MswApiService.createCustomer.createUserGrp(newUserGroupname, this.defaultCustomer.productGroupId)
      .then((resp: any) => {
        this.$store.commit('stopLoading');
        if (resp.operationStatus === 'NOK') {
          const message: InfoState = { infoType: 'high', infoMsg: resp.msgDesc };
          this.$store.commit('displayMessage', message);
        } else {
          this.scrollUserGroupToTop = true;
          this.$store.commit('startLoading');
          MswApiService.createCustomer.getUserGroup()
          .then((resp: any) => {
            // this.$store.commit('stopLoading');
            if (resp.operationStatus === 'OK') {
              resp?.userGroups?.find((ele: any) => {
                if (ele.partyGroupName === newUserGroupname) {
                  this.selectedPartyGroupId = ele.partyGroupId;
                }
              });
            }
          })
          .then(() => {
            if (this.$store.getters.isLargeCustomer) {
              MswApiService.createCustomer.getUserGroup()
              .then((ugResponse: any) => {
                this.$store.commit('stopLoading');
                this.addUserGroupForLargeCustomer(ugResponse, resp.usergroup);
              });
            } else {
              this.loadUserGroups();
            }
            this.addedNewUserGroup = true;
            this.newUserGroupName = newUserGroupname;
            this.selectedExtensionTab = 'user-groups-customer-tab';
            this.$store.dispatch('MswUserGroupStoreModule/userGroupSelected', [this.selectedPartyGroupId]);
            const message: InfoState = { infoType: 'success', infoMsg: resp.msgDesc };
            this.$store.commit('displayMessage', message);
          });
        }
      })
      .catch((error: ApiError) => {
        this.$store.commit('stopLoading');
        this.loadUserGroups();
        const message: InfoState = { infoType: 'high', infoMsg: error.message || 'Unknown Error' };
        this.$store.commit('displayMessage', message);
      });
      this.userGroupCount = this.userGroupResponse.length;
      // this.showExtension = true;
    } else {
      let listItemPartyGroupId;
      const data = this.$refs.createUserGroup as CreateUserGroup;
      data.listItems.forEach((ele : any, i : any) => {
        if (i === index) {
          listItemPartyGroupId = ele.partyGroupId;
        }
      });
      console.warn('%c ---------------------------', 'color:red');
      console.warn(`%c ${listItemPartyGroupId}`, 'color:red');
      // this.userGroupResponse[index].name = newUserGroup;
      const dataToBeEdited = {
        partyGroupId: listItemPartyGroupId,
        newPartyGroupName: newUserGroupname,
        bSendMail: false,
      };
      this.$store.commit('startLoading');
      MswApiService.createCustomer.editUserGroup(dataToBeEdited)
      .then((resp: any) => {
        if (this.selectedUser.length > 0) {
          // this.selectedUser[0].usersForUserGroup.splice(0, this.selectedUser[0].usersForUserGroup.length); // ??
        }
        this.newGrpName = '';
        if (resp.operationStatus === 'NOK') {
          this.$store.commit('stopLoading');
          this.$store.dispatch('MswUserGroupStoreModule/userGroupSelected', []);
          this.showExtension = false;
          window.parent.postMessage({
            showHelp : this.showExtension,
          },                        '*');
          const message: InfoState = { infoType: 'high', infoMsg: resp.msgDesc };
          this.$store.commit('displayMessage', message);
        } else {
          if (this.$store.getters.isLargeCustomer) {
            MswApiService.createCustomer.getUserGroup()
             .then((response: any) => {
               this.updateUserGroupNameForLargeCustomer(response, dataToBeEdited.partyGroupId, newUserGroupname);
             });
          } else {
            this.updateUserGroupName(dataToBeEdited.partyGroupId);
          }
          if (this.selectedUserGroup.length > 0) {
            this.$store.dispatch('MswUserGroupStoreModule/userGroupSelected', [dataToBeEdited.partyGroupId]);
          }
          const message: InfoState = { infoType: 'success', infoMsg: resp.msgDesc };
          this.$store.commit('displayMessage', message);
        }
      });
    }
  }

  addUserGroupForLargeCustomer(ugResponse: any, userGroup : any) {
    const ugObj = Object.assign({}, userGroup);
    this.userGroupResponse.splice(1, 0, this.assignProductGroupsToUserGroup(ugObj, ugObj, false, true));
    this.$set(this.userGroupResponse, 0 , this.userGroupResponse[0]);
    ugResponse.userGroups.splice(1, 0 , userGroup);
    this.userGroupCount = this.userGroupResponse.length;
    this.saveForageDataForUserGroup(ugResponse, userGroup.partyGroupId);
  }

  updateUserGroupNameForLargeCustomer(response : any, partyGroupId : any, newUserGroupname : any) {
    for (let i = 0; i < response.userGroups.length; i += 1) {
      if (response.userGroups[i].partyGroupId === partyGroupId) {
        const userGroupIndex = this.userGroupResponse.findIndex((ele : any) => ele.partyGroupId === partyGroupId);
        const tempObj = this.userGroupResponse[userGroupIndex];
        tempObj.partyGroupName = newUserGroupname;
        this.$set(this.userGroupResponse, userGroupIndex , tempObj);
        response.userGroups[i].partyGroupName = newUserGroupname;
        this.saveForageDataForUserGroup(response, partyGroupId);
        break;
      }
    }
    this.$store.commit('stopLoading');
  }

  // tslint:disable-next-line:no-unused
  updateUserGroupName(partyGroupId : any) {
    this.$store.commit('startLoading');
    MswApiService.createCustomer.getUserGroup()
    .then((resp: any) => {
      this.$store.commit('stopLoading');
      for (let i = 0; i < resp.userGroups.length; i += 1) {
        if (resp.userGroups[i].partyGroupId === partyGroupId) {
          const userGroupIndex = this.userGroupResponse.findIndex((ele : any) => ele.partyGroupId === partyGroupId);
          const tempObj = this.userGroupResponse[userGroupIndex];
          tempObj.partyGroupName = resp.userGroups[i].partyGroupName;
          this.$set(this.userGroupResponse, userGroupIndex , tempObj);
          break;
        }
      }
    });
  }

  deleteUserGroup(index: any) {
    const data = this.$refs.createUserGroup as CreateUserGroup;
    let userListUserGroupId;
    data.listItems.forEach((ele : any, i : any) => {
      if (i === index) {
        userListUserGroupId = ele.partyGroupId;
      }
    });
    this.userGroupDataToBeDeleted.userGroupList.push({
      partyGroupId: userListUserGroupId,
    });
    this.deleteUserGroupApi(this.userGroupDataToBeDeleted);
    this.userGroupCount = this.userGroupResponse.length;
  }

  removeUser(user: any) {
    const index = this.selectedUser[0].usersForUserGroup.findIndex((ele : any) => ele.partyId === user.partyId);
    const usersTobeDeleted = {
      bsendMail: null,
      contactLists: [{
        partyGroupId: this.addUsersId,
        partyId: this.selectedUser[0].usersForUserGroup[index].partyId,
        action: 'delete',
      }],
    };
    this.$store.commit('startLoading');
    MswApiService.createCustomer.manageUsers(usersTobeDeleted)
    .then((resp: any) =>  {
      this.$store.commit('stopLoading');
      // this.selectedUser[0].usersForUserGroup.splice(0, this.selectedUser[0].usersForUserGroup.length); // ??
      if (this.$store.getters.isLargeCustomer) {
        // idb.refreshStore(USERGROUP_STORE_NAME)
        //   .then(() => {
        //     this.loadUserGroupTemp();
        //   });
        this.removeUserFromUserGroup(usersTobeDeleted);
      } else {
        this.selectedUser[0].usersForUserGroup.splice(index, 1);
        this.loadUserGroupTemp();
      }
      if (resp.operationStatus === 'NOK') {
        const message: InfoState = { infoType: 'high', infoMsg: resp.msgDesc };
        this.$store.commit('displayMessage', message);
      } else {
        const message: InfoState = { infoType: 'success', infoMsg: resp.msgDesc };
        this.$store.commit('displayMessage', message);
      }
    });
  }
  removeUserFromUserGroup(usersTobeDeleted : any) {
    this.calUpdateUserCount = false;
    this.callUpdatePermission = false;
    this.$store.commit('startLoading');
    MswApiService.createCustomer.getUserGroup()
      .then((resp: any) => {
        const changedResponse = localForageService.deleteUserFromUserGroup(usersTobeDeleted, resp);
        this.selectedUser[0].usersForUserGroup = changedResponse.respOut.userGroups[changedResponse.ugIndexChanged].usersForUserGroup;
        // tslint:disable-next-line:max-line-length
        const ugIndexInNewUserGroupResponse = this.userGroupResponse.findIndex((ele : any) => ele.partyGroupId === usersTobeDeleted.contactLists[0].partyGroupId);
        // tslint:disable-next-line:max-line-length
        this.userGroupResponse[ugIndexInNewUserGroupResponse].usersForUserGroup = changedResponse.respOut.userGroups[changedResponse.ugIndexChanged].usersForUserGroup;
        this.$set(this.userGroupResponse , ugIndexInNewUserGroupResponse, this.userGroupResponse[ugIndexInNewUserGroupResponse]);
        // tslint:disable-next-line:max-line-length
        const ugIndexInNewUserGroupResponse2 = this.userGroupResponseRaw.findIndex((ele : any) => ele.partyGroupId === usersTobeDeleted.contactLists[0].partyGroupId);
        // tslint:disable-next-line:max-line-length
        this.userGroupResponseRaw[ugIndexInNewUserGroupResponse2].usersForUserGroup = changedResponse.respOut.userGroups[changedResponse.ugIndexChanged].usersForUserGroup;
        this.callUpdatePermission = true;
        this.calUpdateUserCount = true;
        // tslint:disable-next-line:max-line-length
        this.userGroupIdUpdate = `${changedResponse.respOut.userGroups[changedResponse.ugIndexChanged].partyGroupId},${usersTobeDeleted.contactLists[0].partyId}`;
        this.saveForageDataForUserGroup(changedResponse.respOut, '');
        this.$store.commit('stopLoading');
      });
  }

  removeCustomer(index: any) {
    this.loadCustomerOnChange = '';
    if (this.selectedUser[0].assignedProductGroup.length > 1) {
      this.$store.commit('startLoading');
      const backUpProductGroup: any[] = _.cloneDeep(this.selectedUser[0].assignedProductGroup) || [];
      const dataToBeManaged:any = {
        partyProductGroupList: [],
        bsendMail: false,
        deletedProductGroupId: this.selectedUser[0].assignedProductGroup[index].productGroupId,
      };
      const deletedProductGroupId = this.selectedUser[0].assignedProductGroup[index].productGroupId;
      const deletedPG = this.selectedUser[0].assignedProductGroup[index];
      const deletedUg = this.selectedUser[0];
      this.selectedUser[0].assignedProductGroup.splice([index], 1);
      this.selectedUser[0].assignedProductGroup.map((ele: any) => {
        dataToBeManaged.partyProductGroupList.push({
          productGroupId: ele.productGroupId,
          partyGroupId: this.addUsersId,
        });
      });
      MswApiService.createCustomer.postManageUserProductGroup(dataToBeManaged)
      .then((resp: any) => {
        this.selectedUser[0].assignedProductGroup.splice(0, this.selectedUser[0].assignedProductGroup.length);
        // this.loadUserGroups();
        if (resp.operationStatus === 'NOK') {
          const message: InfoState = { infoType: 'high', infoMsg: resp.msgDesc };
          this.$store.commit('displayMessage', message);
          this.selectedUser[0].assignedProductGroup  = _.cloneDeep(backUpProductGroup);
          this.$set(this.selectedUser, 0 , this.selectedUser[0]);
          this.$store.commit('stopLoading');
        } else {
          if (this.$store.getters.isLargeCustomer) {
            this.callUpdatePermission = false;
            Promise.all([
              this.$store.dispatch('DashBoardStoreModule/populateCustomerWidgets', false),
              MswApiService.createCustomer.getUserGroup(false),
            ])
            // tslint:disable-next-line:no-unused
          .then((resp: any) => {
            // tslint:disable-next-line:max-line-length
            const changedProductGroupId = resp[0].prodGroupLicenseStatus.findIndex((ele : any) => ele.productGroupId === deletedPG.productGroupId);
            const changedUserGroupId = resp[1].userGroups.findIndex((ele : any) => ele.partyGroupId === deletedUg.partyGroupId);
            const partyGroupNamesIndex = resp[0].prodGroupLicenseStatus[changedProductGroupId].partyGroupName.indexOf(`${deletedUg.partyGroupName},`);
            // tslint:disable-next-line:max-line-length
            const customerListIndex = this.customersListResponse.findIndex((ele : any) => ele.productGroupId === deletedPG.productGroupId);
            const userGroupResIndex = this.userGroupResponse.findIndex((ele : any) => ele.partyGroupId === deletedUg.partyGroupId);
            if (partyGroupNamesIndex === -1) {
                // tslint:disable-next-line:max-line-length
              resp[0].prodGroupLicenseStatus[changedProductGroupId].partyGroupName = resp[0].prodGroupLicenseStatus[changedProductGroupId].partyGroupName.replace(`, ${deletedUg.partyGroupName}`, '');
            } else {
                // tslint:disable-next-line:max-line-length
              resp[0].prodGroupLicenseStatus[changedProductGroupId].partyGroupName = resp[0].prodGroupLicenseStatus[changedProductGroupId].partyGroupName.replace(`${deletedUg.partyGroupName}, `, '');
            }
            // tslint:disable-next-line:max-line-length
            const productGroupNameIndex = resp[1].userGroups[changedUserGroupId].productGroupName.indexOf(`${resp[0].prodGroupLicenseStatus[changedProductGroupId].productGroupName}^&`);
            if (productGroupNameIndex === -1) {
              // tslint:disable-next-line:max-line-length
              resp[1].userGroups[changedUserGroupId].productGroupName = resp[1].userGroups[changedUserGroupId].productGroupName.replace(`^& ${resp[0].prodGroupLicenseStatus[changedProductGroupId].productGroupName}`, '');
            } else {
              // tslint:disable-next-line:max-line-length
              resp[1].userGroups[changedUserGroupId].productGroupName = resp[1].userGroups[changedUserGroupId].productGroupName.replace(`${resp[0].prodGroupLicenseStatus[changedProductGroupId].productGroupName}^& `, '');
            }
            if (customerListIndex === -1) {
              if (this.defaultCustomer.productGroupId === deletedPG.productGroupId) {
                this.defaultCustomer.partyGroupName = resp[0].prodGroupLicenseStatus[changedProductGroupId].partyGroupName;
              }
              const i = this.selectedCustomerResponse.findIndex((ele : any) => ele.productGroupId === deletedPG.productGroupId);
              if (i > -1) {
                this.selectedCustomerResponse[i].partyGroupName = resp[0].prodGroupLicenseStatus[changedProductGroupId].partyGroupName;
              }
            } else {
              this.customersListResponse[customerListIndex].partyGroupName = resp[0].prodGroupLicenseStatus[changedProductGroupId].partyGroupName;
            }
            this.userGroupResponse[userGroupResIndex].productGroupName = resp[1].userGroups[changedUserGroupId].productGroupName;
            // this.$set(this.customersListResponse, customerListIndex, this.customersListResponse[customerListIndex]);
            // this.$set(this.userGroupResponse, userGroupResIndex, this.userGroupResponse[userGroupResIndex]);
            this.saveForageData(resp[0], '');
            const ind = this.userGroupResponse[userGroupResIndex].associatedPGList.findIndex((ele : any) => ele.productGroupId === deletedProductGroupId);
            this.userGroupResponse[userGroupResIndex].associatedPGList.splice([ind], 1);
            // tslint:disable-next-line:max-line-length
            this.userGroupResponse[userGroupResIndex] = this.assignProductGroupsToUserGroup(this.userGroupResponse[userGroupResIndex], this.userGroupResponse[userGroupResIndex], false, true);
            this.selectedUser[0].assignedProductGroup = this.userGroupResponse[userGroupResIndex].assignedProductGroup;
            this.selectedUser[0].availableProductGroup = this.userGroupResponse[userGroupResIndex].availableProductGroup;
            resp[1].userGroups[changedUserGroupId].assignedProductGroup = this.selectedUser[0].assignedProductGroup;
            resp[1].userGroups[changedUserGroupId].availableProductGroup = this.selectedUser[0].availableProductGroup;
            this.saveForageDataForUserGroup(resp[1], '');
            if (!this.selectedUser[0].hasOwnProperty('usersForUserGroup')) {
              this.selectedUser[0]['usersForUserGroup'] = [];
            }
            this.$set(this.selectedUser, 0 , this.selectedUser[0]);
            this.callUpdatePermission = true;
            this.$store.commit('startLoading');
          });
          } else {
            // this.loadUserGroups();
            this.loadCustomerOnChange = this.selectedUser[0].partyGroupId;
          }
          const message: InfoState = { infoType: 'success', infoMsg: resp.msgDesc };
          // idb.refreshStore(PRODUCTS_STORE_NAME);
          this.$store.commit('displayMessage', message);
        }
      })
      .catch(() => {
        this.loadUserGroups();
      });
    } else {
      const message: InfoState = { infoType: 'high', infoMsg: 'Please ensure atleast one product group is assigned to the user group' };
      this.$store.commit('displayMessage', message);
    }
  }

  onAssignCustomer() {
    this.assignCustomerModal = true;
    this.createUserModal = false;
    this.createCustomerModal = false;
    // this.loadCustomerForUser();
  }
  loadCustomerForUser() {
    this.$store.commit('startLoading');
    MswApiService.createCustomer.getProductGroupList('userGroup')
    .then((resp: any) => {
      // if (this.userGroupResponseRaw) {
      //   if (this.userGroupResponse.length === this.userGroupResponseRaw.length) {
      //     this.$store.commit('stopLoading');
      //   }
      // } else {
      //   this.$store.commit('stopLoading');
      // }
      this.customersListResponse = [];
      this.selectedCustomerResponseForUser = resp.hasOwnProperty('productGroup') ? resp.productGroup : [];
      this.selectedCustomerResponseForUser.map((ele: any) => {
        if (ele.isDefaultGroup === 'TRUE' && ele.sharedGroup !== 'TRUE') {
          this.selectedCustomerResponse = [ele];
          this.defaultCustomer = ele;
        } else {
          this.customersListResponse.push(ele);
        }
      });
      this.loadUserGroups();
    })
    .catch((error: ApiError) => {
      this.$store.commit('stopLoading');
      const message: InfoState = { infoType: 'high', infoMsg: error.message || 'Unknown Error' };
      this.$store.commit('displayMessage', message);
    });
  }
  loadCustomerForUserLargeCustomer(forceFetch = false) {
    this.$store.commit('startLoading');
    Promise.all([
      this.$store.dispatch('DashBoardStoreModule/populateCustomerWidgets', forceFetch),
      MswApiService.createCustomer.getUserGroup(forceFetch),
    ])
    .then((resp: any) => {
      this.selectedCustomerResponseForUser = resp[0].hasOwnProperty('prodGroupLicenseStatus') ? resp[0].prodGroupLicenseStatus : [];
      this.customersListResponse = JSON.parse(JSON.stringify(this.selectedCustomerResponseForUser));
      const ind = this.customersListResponse.findIndex((ele : any) => ele.isDefaultGroup === 'TRUE' && ele.sharedGroup !== 'TRUE');
      if (ind > -1) {
        this.selectedCustomerResponse = [this.selectedCustomerResponseForUser[ind]];
        this.defaultCustomer = this.selectedCustomerResponseForUser[ind];
      }
      this.customersListResponse.splice(ind, 1);
      this.loadUserGroupsForLargeCustomer(resp[1]);
    })
    .catch((error: ApiError) => {
      this.$store.commit('stopLoading');
      const message: InfoState = { infoType: 'high', infoMsg: error.message || 'Unknown Error' };
      this.$store.commit('displayMessage', message);
    });
  }
  loadUserGroupsForLargeCustomer(resp: any) {
    let userGrpResponseRecieved: any = [];
    this.userGroupResponse = [];
    userGrpResponseRecieved = resp || [];
    if (userGrpResponseRecieved.hasOwnProperty('userGroups')) {
      if (userGrpResponseRecieved.userGroups.length === 0) this.$store.commit('stopLoading');
      this.userGroupResponseRaw = userGrpResponseRecieved.userGroups;
      const defaultUgIndex = resp.userGroups.findIndex((ele : any) => ele.isDefaultGroup.toLowerCase() === 'true');
      this.showUserGroupList = true;
      this.userGroupResponse  = JSON.parse(JSON.stringify(userGrpResponseRecieved.userGroups));
      if (defaultUgIndex > -1) {
        const selectedUserCopy = resp.userGroups[defaultUgIndex];
        Promise.all([
          MswApiService.createCustomer.getUserGroupPermissions(selectedUserCopy.partyGroupId),
          MswApiService.createCustomer.listUsersForUserGroup(selectedUserCopy.partyGroupId),
        ])
        .then((resp: any) => {
          this.loadPermissionAndUserList(resp, selectedUserCopy, false, true);
        });
      } else {
        this.$store.commit('stopLoading');
      }
    } else {
      this.$store.commit('stopLoading');
    }
    this.userGroupCount = userGrpResponseRecieved.hasOwnProperty('userGroups') ? userGrpResponseRecieved.userGroups.length : 0;
    this.addUserGroup = userGrpResponseRecieved.showCreateUserGrplink === 'true';
  }

  beforeDestroy() {
    // this.setHelpContentId({ helpId: 'default' });
    // this.setHelpContainerSlideVisible({ visible: false });
  }

  destroyed() {
    window.parent.removeEventListener('storage', () => {});
  }

  // tslint:disable-next-line:no-unused
  onMakeDefault(index: any, flag: boolean) {
    this.scrollUserGroupToTop = false;
    const data = this.$refs.createUserGroup as CreateUserGroup;
    let userListUserGroupId;
    data.listItems.forEach((ele : any, i : any) => {
      if (i === index) {
        userListUserGroupId = ele.partyGroupId;
      }
    });
    this.makeDefaultGroup.GroupId = userListUserGroupId;
    this.buttons = [
      { key: 'cancel', name: 'Cancel', isDefault: true },
      { key: 'yes', name: 'Yes' },
    ];
    const defaultUgId = this.userGroupResponseRaw.filter((ele : any) => ele.isDefaultGroup.toLowerCase() === 'true');
    const changedDefaultId = this.userGroupResponseRaw.filter((ele : any) => ele.partyGroupId === this.makeDefaultGroup.GroupId);
    this.options = {
      status: 'informational',
      title: 'Confirmation',
      // tslint:disable-next-line:no-unused
      message : (h: CreateElement): VNode => {
        return h('div', {
          // tslint:disable-next-line:max-line-length
          domProps: { innerHTML: defaultUgId.length > 0 ?
          // tslint:disable-next-line:max-line-length
          `Setting the default group would give admin access to all the users of that group to all the tenants. Are you sure you want to change the default user group from <b>${defaultUgId[0].partyGroupName}</b> to <b>${changedDefaultId[0].partyGroupName}</b> ?` :
          // tslint:disable-next-line:max-line-length
          `Setting the default group would give admin access to all the users of that group to all the tenants. Are you sure you want to change the default user group to <b>${changedDefaultId[0].partyGroupName}</b> ?` },
        });
      },
      buttons: this.buttons,
    };
    confirmService.confirm(this.options)
    .then((key) => {
      if (key === 'yes') {
        this.$store.commit('startLoading');
        MswApiService.createCustomer.manageDefaultGroup(this.makeDefaultGroup)
      .then((resp: any) => {
        if (resp.operationStatus === 'NOK') {
          this.$store.commit('stopLoading');
          const message: InfoState = { infoType: 'high', infoMsg: resp.msgDesc };
          this.$store.commit('displayMessage', message);
        } else {
          this.scrollUserGroupToTop = true;
          this.showExtension = false;
          if (this.$store.getters.isLargeCustomer) {
            idb.refreshStore(USERGROUP_STORE_NAME)
            .then(() => {
              idb.refreshStore(TENANTS_STORE_NAME)
              .then(() => {
                this.loadUserGroups(true);
              });
            });
            //  need to change it without api call
            // MswApiService.createCustomer.getUserGroup()
            //  .then((response: any) => {
            //    this.deleteUserGroupForLargeCustomer(response, data.userGroupList[0].partyGroupId);
            //  });
          } else {
            this.loadUserGroups();
          }
          // this.makeDefaultUserGroup(this.makeDefaultGroup.GroupId);
          const message: InfoState = { infoType: 'success', infoMsg: resp.msgDesc };
          this.$store.commit('displayMessage', message);
        }
      });
      }
    });
  }
  makeDefaultUserGroup(partyGroupId : any) {
    this.scrollUserGroupToTop = false;
    const data = this.$refs.createUserGroup as CreateUserGroup;
    this.$store.commit('startLoading');
    MswApiService.createCustomer.getUserGroup()
    .then((resp: any) => {
      this.$store.commit('stopLoading');
      if (resp.operationStatus === 'OK') {
        let oldPartyGroupId : any = null;
        if (data.listItems.filter((ele : any) => ele.isDefaultGroup === 'TRUE').length > 0) {
          oldPartyGroupId = data.listItems.filter((ele : any) => ele.isDefaultGroup === 'TRUE')[0].partyGroupId;
        }
        let oldUpdatedObj : any;
        let newUpdatedObj : any;
        for (let i = 0; i < resp.userGroups.length; i += 1) {
          if (resp.userGroups[i].isDefaultGroup === 'TRUE' && resp.userGroups[i].partyGroupId === partyGroupId) {
            newUpdatedObj = {
              partyGroupName: resp.userGroups[i].hasOwnProperty('partyGroupName') ? resp.userGroups[i].partyGroupName : '',
              usersForUserGroup: resp.userGroups[i].hasOwnProperty('usersForUserGroup') ? resp.userGroups[i].usersForUserGroup  : {},
              isDefaultGroup: resp.userGroups[i].hasOwnProperty('isDefaultGroup') ? resp.userGroups[i].isDefaultGroup : 'FALSE',
              renameLink: resp.userGroups[i].renameLink,
              deleteLink: resp.userGroups[i].deleteLink,
              setAsDefaultGroup: resp.userGroups[i].setAsDefaultGroup,
              partyGroupId : resp.userGroups[i].partyGroupId,
            };
          }
          if (resp.userGroups[i].partyGroupId === oldPartyGroupId) {
            oldUpdatedObj = {
              partyGroupName: resp.userGroups[i].hasOwnProperty('partyGroupName') ? resp.userGroups[i].partyGroupName : '',
              usersForUserGroup: resp.userGroups[i].hasOwnProperty('usersForUserGroup') ? resp.userGroups[i].usersForUserGroup  : {},
              isDefaultGroup: resp.userGroups[i].hasOwnProperty('isDefaultGroup') ? resp.userGroups[i].isDefaultGroup : 'FALSE',
              renameLink: resp.userGroups[i].renameLink,
              deleteLink: resp.userGroups[i].deleteLink,
              setAsDefaultGroup: resp.userGroups[i].setAsDefaultGroup,
              partyGroupId : resp.userGroups[i].partyGroupId,
            };
          }
        }
        this.userGroupResponse.forEach((ele: any, index : any) => {
          if (oldPartyGroupId === null) {
            if (ele.isDefaultGroup === 'TRUE' && ele.partyGroupId !== partyGroupId) {
              oldUpdatedObj = {
                partyGroupName: ele.hasOwnProperty('partyGroupName') ? ele.partyGroupName : '',
                usersForUserGroup: ele.hasOwnProperty('usersForUserGroup') ? ele.usersForUserGroup  : {},
                isDefaultGroup: ele.hasOwnProperty('isDefaultGroup') ? ele.isDefaultGroup : 'FALSE',
                renameLink: ele.renameLink,
                deleteLink: ele.deleteLink,
                setAsDefaultGroup: ele.setAsDefaultGroup,
                partyGroupId : ele.partyGroupId,
              };
              oldPartyGroupId = oldUpdatedObj.partyGroupId;
            }
          }
          if (ele.partyGroupId === oldPartyGroupId) {
            this.$set(this.userGroupResponse, index, oldUpdatedObj);
          }
          if (ele.partyGroupId === partyGroupId) {
            const tempObj = this.userGroupResponse[0];
            this.userGroupResponse[index] = tempObj;
            this.userGroupResponse[0] = newUpdatedObj;
            this.$set(this.userGroupResponse, 0, this.userGroupResponse[0]);
          }
        });
        this.scrollUserGroupToTop = true;
      }
    });
  }

  deleteUserGroupApi(data: any) {
    this.$store.commit('startLoading');
    MswApiService.createCustomer.deleteUserGroup(data)
    .then((resp: any) => {
      // this.$store.commit('stopLoading');
      this.userGroupDataToBeDeleted = {
        bsendMail: false,
        userGroupList: [],
      };
      if (resp.msgCode !== 'MSWAPP:DELTEUSERGROUPSUCCESS') {
        this.$store.commit('stopLoading');
        const message: InfoState = { infoType: 'high', infoMsg: resp.msgDesc };
        this.$store.commit('displayMessage', message);
      } else {
        if (this.$store.getters.isLargeCustomer) {
          MswApiService.createCustomer.getUserGroup()
             .then((response: any) => {
               this.deleteUserGroupForLargeCustomer(response, data.userGroupList[0].partyGroupId);
             });
        } else {
          this.deleteUserGroupTemp(data.userGroupList[0].partyGroupId);
        }
        const message: InfoState = { infoType: 'success', infoMsg: resp.msgDesc };
        this.$store.commit('displayMessage', message);
      }
      // this.loadDefaultGroup();
    });
  }
  deleteUserGroupForLargeCustomer(response : any, partyGroupId : any) {
    const ind = this.userGroupResponse.findIndex((ele: any) => ele.partyGroupId === partyGroupId);
    this.userGroupResponse.splice(ind, 1);
    const data = this.$refs.createUserGroup as CreateUserGroup;
    const userListInd =  data.listItems.findIndex((ele : any) => ele.partyGroupId === partyGroupId);
    data.listItems.splice(userListInd, 1);
    const responseIndex = response.userGroups.findIndex((ele : any) => ele.partyGroupId === partyGroupId);
    response.userGroups.splice(responseIndex, 1);
    this.userGroupCount = response.userGroups.length;
    this.saveForageDataForUserGroup(response, partyGroupId);
    this.$store.commit('stopLoading');
  }
  deleteUserGroupTemp(partyGroupId : any) {
    this.$store.commit('startLoading');
    MswApiService.createCustomer.getUserGroup()
    .then((resp: any) => {
      this.$store.commit('stopLoading');
      if (resp.operationStatus === 'OK') {
        this.$store.commit('stopLoading');
        let flag = false;
        for (let i = 0; i < resp.userGroups.length; i += 1) {
          if (resp.userGroups[i].partyGroupId === partyGroupId) {
            flag = true;
          }
        }
        if (!flag) {
          const ind = this.userGroupResponse.findIndex((ele: any) => ele.partyGroupId === partyGroupId);
          this.userGroupResponse.splice(ind, 1);
          const data = this.$refs.createUserGroup as CreateUserGroup;
          const userListInd =  data.listItems.findIndex((ele : any) => ele.partyGroupId === partyGroupId);
          data.listItems.splice(userListInd, 1);
          this.$set(this.userGroupResponse, 0, this.userGroupResponse[0]);
          this.userGroupCount = this.userGroupResponse.length;
        }
      }
    });
  }
  // tslint:disable-next-line:no-unused
  saveForageDataForUserGroup(newResponse : any , id: any, callDefaultUserGroup = false) {
    MswApiService.createCustomer.saveUserGroupList({}, newResponse)
    .then(() => {
      MswApiService.createCustomer.getUserGroup()
      .then((response: any) => {
        console.warn(response.userGroups);
      });
    });
  }
  checkAndAddProductGroup() {
    // tslint:disable-next-line:no-unused
    const ind = this.userGroupResponse.findIndex((ele : any) => ele.partyGroupId === this.selectedPartyGroupId);
    if (this.userGroupResponse[ind].hasOwnProperty('assignedProductGroup') && this.userGroupResponse[ind].hasOwnProperty('availableProductGroup')) {
      return;
    }
    this.$set(this.userGroupResponse, ind , this.assignProductGroupsToUserGroup(this.userGroupResponse[ind], this.userGroupResponse[ind], false, true));
  }
  // tslint:disable-next-line:no-unused
  saveForageData(newResponse : any , id: any) {
    MswApiService.createCustomer.saveProductsDetailList({}, newResponse)
    .then(() => {
      this.$store.dispatch('DashBoardStoreModule/populateCustomerWidgets')
      .then((response: any) => {
        console.warn(response);
        this.$store.commit('stopLoading');
      });
    });
  }
}
